//import Vue from 'vue'

const state = {
	postData:[
	'',
	'',
    '',
	]
}

const mutations = {
	'CHANGE_QNFORYUMA2024'(state, val){
		state.postData = val
	},
};

const actions = {
	set_qnforyuma2024:({commit},val) => {
		commit('CHANGE_QNFORYUMA2024',val)
	},
};

const getters = {
	get_qnforyuma2024: state => {
		return state.postData
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
}